import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'arrayJoin'})
export class ArrayJoinPipe implements PipeTransform {
    transform(arr: string[], separator = ''): string {
        return arr.join(separator);
    }
}
